import axios from '@/js/helper/axios-helper.js'
import { isEmpty } from 'lodash-es'

// let csrfToken = null

const responseCheck = status => response => {
  return response.status === status ? response.data : { errors: response.data }
}

const requestCatch = err => {
  const responseData = err.response ? err.response.data : err
  return { errors: isEmpty(responseData) ? { status: err.status || 'err' } : responseData }
}

export const getUsermanagementApi = url => {
  return {
    requestList: () => {
      return axios.get(`${url}/api/subusers`).then(data => {
        // csrfToken = data?.data?.csrf_token
        return data
      })
    },
    createUser: (id, data) => {
      return axios
        .post(`${url}/api/subuser`, data, {
          // headers: {
          //   'X-CSRF-TOKEN': csrfToken,
          // },
        })
        .then(responseCheck(201))
        .catch(requestCatch)
    },
    saveUser: (id, data) => {
      return axios
        .patch(`${url}/api/subuser/${id}`, data)
        .then(responseCheck(200))
        .catch(requestCatch)
    },
    saveTemplate: (id, data) => {
      return axios
        .patch(`${url}/api/usertemplate/${id}`, data)
        .then(responseCheck(200))
        .catch(requestCatch)
    },
    saveRoles: (id, data) => {
      return axios
        .patch(`${url}/api/userroles/${id}`, data)
        .then(responseCheck(200))
        .catch(requestCatch)
    },
    deleteUser: id => {
      // console.log({ csrfToken })
      return axios.delete(`${url}/api/subuser/${id}`).then(responseCheck(204)).catch(requestCatch)
    },
    saveSelf: data => {
      return axios.patch(`${url}/api/selfuser`, data).then(responseCheck(200)).catch(requestCatch)
    },
    updateDpSelf: () => {
      return axios.get('/api/bucommonapi?code=updateself')
    },
    submitPartnerEventRegistration: data => {
      return axios
        .post(`${url}/api/partner_event_registration`, data, {})
        .then(responseCheck(200))
        .catch(requestCatch)
    },
    getPartnerEventRegistration: eventKey => {
      return axios
        .get(`${url}/api/partner_event_registration${eventKey ? `?eventKey=${eventKey}` : ''}`)
        .then(data => {
          return data
        })
    },
  }
}
